export const GQL_REQUEST_AMOUNT = 9999
